export const COOKIE_NAME = 'hide_pwa_notification_modal';
